// React
import {useState, useEffect} from "react";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

/*
	Entry popup
	(For testing purposes only)
*/

const EntryPopup = new Popup({
	title: () => "Load Map",
	style: {maxWidth: 600},
	closeable: false,
	render: function() {
		const [mapId, setMapId] = useState<number>(this.get("mapId"));
		const [clientId, setClientId] = useState<number>(this.get("clientId"));
		const [langId, setLangId] = useState<string>(this.get("langId") || "en-GB");
		const [loading, setLoading] = useState<boolean>(false);
			
		const submitMapConfig = () => {
			setLoading(true);
			_ui.showLoading();
			
			_config.mapId = mapId;
			_config.clientId = clientId;
			
			setTimeout(() => _events.invoke("map-viewer-ready"), 100);
		}
		
		return (
			<>
				<p>Development only</p>
				<h3>Map ID</h3>
				
				<p>
					<input type="number" value={mapId} onChange={(e:any) => setMapId(Number(e.target.value))} />
				</p>
				
				<h3>Client ID</h3>
				
				<p>
					<input type="number" value={clientId} onChange={(e:any) => setClientId(Number(e.target.value))} />
				</p>
				
				<hr />
				
				<div style={{marginTop: 15}}>
					<button onClick={submitMapConfig} disabled={loading}>
						Load Map
					</button>
				</div>
			</>
		)
	}
});

export default EntryPopup;